import React, { memo } from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import { MenuItem, Grid } from "@material-ui/core";
import * as R from "ramda";

import {
  DRIVER_FORM_ENTITIES,
  NO_OPTIONS,
  SECTION,
  VEHICLE,
} from "../../../constants/strings";

const DriverInputs = ({ isDisabled, vehicles, sections }) => (
  <>
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <Field
          component={TextField}
          name="dutyStartTime"
          type="text"
          label={DRIVER_FORM_ENTITIES.DUTY_START}
          helperText="HH:MM"
          disabled={isDisabled}
          variant="outlined"
          data-testid="duty-start-time"
        />
      </Grid>
      <Grid item xs={3}>
        <Field
          component={TextField}
          name="dutyEndTime"
          type="text"
          label={DRIVER_FORM_ENTITIES.DUTY_END}
          helperText="HH:MM"
          disabled={isDisabled}
          variant="outlined"
          data-testid="duty-end-time"
        />
      </Grid>
      <Grid item xs={3}>
        <Field
          component={TextField}
          name="plannedDepartTime"
          type="text"
          label={DRIVER_FORM_ENTITIES.DEPART}
          helperText="HH:MM"
          disabled={isDisabled}
          variant="outlined"
          data-testid="planned-depart-time"
        />
      </Grid>
      <Grid item xs={3}>
        <Field
          component={TextField}
          name="plannedReturnTime"
          type="text"
          label={DRIVER_FORM_ENTITIES.RETURN}
          helperText="HH:MM"
          disabled={isDisabled}
          variant="outlined"
          data-testid="planned-return-time"
        />
      </Grid>
    </Grid>
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <Field
          component={TextField}
          name="deliveryStopTime"
          type="text"
          label={DRIVER_FORM_ENTITIES.DELIVERY_STOP}
          helperText="MM:SS"
          disabled={isDisabled}
          variant="outlined"
          data-testid="delivery-stop-time"
        />
      </Grid>
      <Grid item xs={3}>
        <Field
          component={TextField}
          name="collectionStopTime"
          type="text"
          label={DRIVER_FORM_ENTITIES.COLLECTION_STOP}
          helperText="MM:SS"
          disabled={isDisabled}
          variant="outlined"
          data-testid="collection-stop-time"
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          component={TextField}
          select
          name="vehicleTypeCode"
          disabled={isDisabled}
          variant="outlined"
          margin="normal"
          label={VEHICLE}
          fullWidth
          data-testid="vehicle-type-code"
        >
          {vehicles.map((vehicle) => (
            <MenuItem
              value={vehicle.vehicleTypeCode}
              key={vehicle.vehicleTypeCode}
            >
              {vehicle.vehicleTypeDescription || ""}
            </MenuItem>
          ))}
        </Field>
      </Grid>
    </Grid>
    {sections && (
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Field
            component={TextField}
            select
            name="sectionCode"
            disabled={isDisabled}
            variant="outlined"
            margin="normal"
            label={SECTION}
            fullWidth
            data-testid="section-code"
          >
            {!R.isEmpty(sections) ? (
              sections.map((section) => (
                <MenuItem value={section.sectionCode} key={section.sectionCode}>
                  {section.sectionName || ""}
                </MenuItem>
              ))
            ) : (
              <MenuItem value="">{NO_OPTIONS}</MenuItem>
            )}
          </Field>
        </Grid>
      </Grid>
    )}
  </>
);

export default memo(DriverInputs);
